var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./camel_snake_kebab.internals.alter_name.js");require("./camel_snake_kebab.internals.misc.js");
'use strict';